const T = require('prop-types');
const { makeActionCreator } = require('../utils/redux-helpers');
const { NOTIFICATIONS: Types } = require('../action-types');

const OFFER_NOTIFICATION_ID_PREFIX = 'offer:';

const getNotificationIds = ({ id, ids } = {}) => [
    ...(id ? [id] : []),
    ...(ids || [])
];

const getOfferIdFromNotificationId = (id) => {

    if (typeof id !== 'string' || id.indexOf(OFFER_NOTIFICATION_ID_PREFIX) !== 0) {
        return null;
    }

    const offerId = Number(id.slice(OFFER_NOTIFICATION_ID_PREFIX.length));

    return Number.isNaN(offerId) ? null : offerId;
};

const splitOfferNotificationIds = (payload) => {

    return getNotificationIds(payload).reduce((result, id) => {

        const offerId = getOfferIdFromNotificationId(id);

        if (offerId === null) {
            result.notificationIds.push(id);
        }
        else {
            result.offerIds.add(offerId);
        }

        return result;
    }, {
        notificationIds: [],
        offerIds: new Set()
    });
};

module.exports = (context) => {

    const selectors = context.selectors.all;
    const redux = context.redux.hooks;
    const actions = context.actions;
    const api = context.api.nearpeer;

    const markRead = makeActionCreator(Types.MARK_READ, { ids: T.arrayOf(T.string) }, { async: api.notifications.markRead });
    const markOfferNotificationsRead = makeActionCreator(Types.MARK_OFFER_NOTIFICATIONS_READ, { ids: T.arrayOf(T.number) });
    const dismiss = makeActionCreator(Types.DISMISS, { id: T.string, ids: T.arrayOf(T.string) }, {
        async: api.notifications.dismiss,
        after: () => actions.dataFetching.fetchNotifications()
    });
    const dismissOfferNotifications = makeActionCreator(Types.DISMISS_OFFER_NOTIFICATIONS, { ids: T.arrayOf(T.number) });

    return {
        markRead: (payload) => {

            const { notificationIds, offerIds } = splitOfferNotificationIds(payload);

            if (!offerIds.size) {
                return markRead(payload);
            }

            return (dispatch) => {

                dispatch(markOfferNotificationsRead({ ids: [...offerIds] }));

                if (!notificationIds.length) {
                    return Promise.resolve();
                }

                return dispatch(markRead({ ids: notificationIds }));
            };
        },
        clearMentions: makeActionCreator(Types.CLEAR_MENTIONS, { channelSid: T.string }, {
            async: ({ channelSid }) => {

                if (!selectors.hasMentions(redux.getState(), channelSid)) {
                    return { ids: [] };
                }

                return api.notifications.clearMentions({ channelSid });
            }
        }),
        accept: makeActionCreator(Types.ACCEPT, { id: T.string, type: T.string, userId: T.string }, {
            async: api.notifications.accept,
            after: ({ dispatch, payload: { request } }) => {

                dispatch(actions.dataFetching.fetchSync());

                if (request.type === 'peer') {
                    dispatch(actions.dataFetching.fetchChannels());
                }
            }
        }),
        acceptTransfer: makeActionCreator(Types.ACCEPT_TRANSFER, { notificationId: T.string }, { async: api.notifications.acceptTransfer }),
        decline: makeActionCreator(Types.DECLINE, { id: T.string, type: T.string, userId: T.string }, {
            async: api.notifications.decline,
            after: () => actions.dataFetching.fetchSync()
        }),
        answerQuestion: makeActionCreator(Types.ANSWER_QUESTION, { notificationId: T.string, answer: T.string }, {
            async: api.notifications.answerQuestion,
            after: () => actions.dataFetching.fetchSync()
        }),
        dismiss: (payload) => {

            const { notificationIds, offerIds } = splitOfferNotificationIds(payload);

            if (!offerIds.size) {
                return dismiss(payload);
            }

            return (dispatch) => {

                dispatch(dismissOfferNotifications({ ids: [...offerIds] }));

                if (notificationIds.length) {
                    return dispatch(dismiss({ ids: notificationIds }));
                }

                return Promise.resolve();
            };
        },
        deleteScheduledNotification: makeActionCreator(Types.DELETE_SCHEDULED_NOTIFICATION, { notificationId: T.number }, {
            async: api.notifications.delete,
            after: () => actions.dataFetching.fetchScheduledNotifications()
        })
    };
};
